import { Stack, Typography } from "@mui/material";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";
import { t } from "i18next";

const diplayRows = [
  "date_and_month",
  "worker_upcomming_job_detail",
  "worker_upcomming_job_price",
];

const JobRequest = ({ allJobs, isLoading }) => {
  console.log(allJobs, isLoading, "asdjhsdsadjhjhasjhasdjh");
  return (
    <Template
      primaryHeading={t("upcomingJobRequest")}
      secondaryHeading={t("viewUpcomingJobs")}
    >
      {allJobs?.length == 0 && isLoading?.states === false ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography
            variant="h5"
            fontWeight={600}
            textTransform={"capitalize"}
          >
            {t("noUpcomingJobsFound")}!
          </Typography>
        </Stack>
      ) : (
        <DashboardTable
          showHeader={false}
          tableData={allJobs}
          diplayRows={diplayRows}
        />
      )}
    </Template>
  );
};

export default JobRequest;
